import { IOption } from 'types/common'
import { MemberType } from 'components/Pages/UserPage/UserList/constants'
import { EQualityOfSearchFeature } from 'constants/user'
import { AuthRole } from 'interfaces/auth'
import { EAuthMethodOverride } from 'types/user'
import { ICollection } from 'interfaces/collection'
import { IGroup, IGroupMember } from 'interfaces/group'
import { IProcessWithRelations } from './../process/index'

export declare interface IUser {
  id?: number
  provider?: string
  uid?: string
  authUid?: string
  encryptedPassword?: string
  resetPasswordToken?: string
  resetPasswordSentAt?: Date
  rememberCreatedAt?: Date
  signInCount?: number
  currentSignInAt?: Date
  lastSignInAt?: Date
  currentSignInIp?: string
  lastSignInIp?: string
  confirmationToken?: string
  confirmedAt?: Date
  confirmationSentAt?: Date
  unconfirmedEmail?: string
  firstName?: string
  lastName?: string
  fullName?: string
  username?: string
  image?: string
  email?: string
  ssoEmail?: string
  ssoEmailVerified?: boolean
  ssoEmailBoundAt?: Date
  ssoGraceResetAt?: Date
  ssoLifecycleAutoActionAt?: Date
  tokens?: string
  createdAt?: Date
  updatedAt?: Date
  permissionUpdatedAt?: Date
  organizationId?: number
  admin?: boolean
  employeeId?: string
  mobilePhone?: string
  workPhone?: string
  address1?: string
  address2?: string
  city?: string
  state?: string
  zip?: string
  owner?: boolean
  primaryGroupId?: number
  superAdmin?: boolean
  forceUpdatePassword?: boolean
  disabled?: boolean
  isInactive?: boolean
  isAutoClaimThread?: boolean
  isReportTool?: boolean
  isMessageFullAccess?: boolean
  isResetPassword?: boolean
  manager?: boolean
  sendTextHelpRequests?: boolean
  canCreateCollections?: boolean
  password?: string
  authRoleId?: number
  qualityOfSearchFeature?: EQualityOfSearchFeature
  fcmToken?: string
  authMethodOverride?: EAuthMethodOverride | null
}

export interface IUserWithRelations extends IUser {
  authRole?: AuthRole
  groupMembers?: IGroupMember[]
  groups?: IGroup[]
  userCollections?: IUserCollection[]
  userProcesses?: IUserProcess[]
}

export interface IUserCollection {
  id: number
  userId: number
  collectionId: number
  collection: ICollection
}

export interface IUserProcess {
  id: number
  userId: number
  processId: number
  process: IProcessWithRelations
  isDirectlyShared: boolean
  user: IUser
}

export interface ICreateEditUserRequest
  extends Pick<IUser, 'username' | 'email' | 'authRoleId' | 'firstName' | 'lastName'> {
  groups?: IGroupMember[]
  password?: string
  organizationId?: number
}

export interface IEditEditUserRequest
  extends Pick<
    IUser,
    | 'organizationId'
    | 'username'
    | 'email'
    | 'authRoleId'
    | 'firstName'
    | 'lastName'
    | 'image'
    | 'isInactive'
    | 'disabled'
    | 'isAutoClaimThread'
    | 'qualityOfSearchFeature'
    | 'fcmToken'
    | 'authMethodOverride'
  > {
  groups?: IGroupMember[]
  oldPassword?: string
  newPassword?: string
}

export interface IUsersFilterForm {
  userTypes: string[]
  groups: IOption<string>[]
  sortBy?: string
  statuses?: string[]
}

export interface IUpdateUserPermission {
  isReportTool: boolean
  isMessageFullAccess: boolean
  canCreateCollections: boolean
}

export enum EAuditableType {
  MEDIUM = 'Medium',
  COLLECTION = 'Collection',
  TEXT_CONTENT = 'TextContent',
  STANDARD_OPERATING_PROCEDURE = 'StandardOperatingProcedure',
  STEP = 'Step'
}

export enum EAuditAction {
  LOGIN = 'login',
  CREATE = 'create',
  UPDATE = 'update',
  DESTROY = 'destroy',
  VIEW = 'view',
  NOTE = 'note',
  COMMENT = 'comment'
}

export interface IAudit {
  id?: number
  auditableId?: number
  auditableType?: EAuditableType
  userId?: number
  action?: EAuditAction
  createdAt?: Date
  updatedAt?: Date
}

export interface IAuditWithRelations {
  id: number
  createdAt: Date
  updatedAt: Date
  name: string
  auditableId: number
  auditableType: EAuditableType
  associatedId: number
  associatedType: string
  userId: number
  userType: string
  username: string
  action: EAuditAction
  auditedChanges: string
  version: number
  comment: string
  remoteAddress: string
  requestUuid: string
  process?: IProcessWithRelations
  collection?: ICollection
}

export interface IMemberItem {
  admin: boolean
  memberId: number
  memberType: MemberType
}
